<div class="selects">
  <cc-item-main-select [form]="displayConditionForm"></cc-item-main-select>
  <ndc-dynamic
    *ngIf="displayComponents.firstComponent"
    [ndcDynamicComponent]="displayComponents.firstComponent"
    [ndcDynamicInputs]="dynamicInputs"></ndc-dynamic>
</div>
<ndc-dynamic
  *ngIf="displayComponents.secondComponent"
  [ndcDynamicComponent]="displayComponents.secondComponent"
  [ndcDynamicInputs]="dynamicInputs"></ndc-dynamic>
